export default {
      id: "icon--chevron-filled-usage",
      viewBox: "0 0 17 9",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--chevron-filled-usage",
      toString: function () {
        return this.url;
      }
    }